import * as React from 'react';

import type { CompletedProjectPictureProps } from './completed-project.picture.props';

const CompletedProjectPicture: React.FC<CompletedProjectPictureProps> = function(props) {
  const { type } = props;

  const isPng  = React.useMemo(() => {
    return !['image/gif', 'image/svg'].includes(type);
  }, [type]);
  const sizes  = React.useMemo(() => {
    if (!isPng) {
      return;
    }

    return [
      '(max-width: 767px) 768px',
      '(min-width: 768px) and (max-width: 1151px) 1152px',
      '1920px',
    ].join(', ');
  }, [isPng]);
  const src    = React.useMemo(() => {
    if (!isPng) {
      return props.src;
    }

    return `${props.src}.png?w=498&default=vertical&t=${BUILD_TIME}`;
  }, [isPng, props.src]);
  const srcSet = React.useMemo(() => {
    if (!isPng) {
      return;
    }

    return [
      `${props.src}.png?w=498&default=vertical&t=${BUILD_TIME} 768w`,
      `${props.src}.png?w=374&default=vertical&t=${BUILD_TIME} 1152w`,
      `${props.src}.png?w=287&default=vertical&t=${BUILD_TIME} 1920w`,
    ].join(', ');
  }, [isPng, props.src]);
  const image  = React.useMemo(() => {
    return (
      <picture>
        {isPng && (
          <>
            <source
              media={'(max-width: 767px)'}
              srcSet={`${props.src}.webp?w=498&default=vertical&t=${BUILD_TIME}`}
              type={'image/webp'}
            />
            <source
              media={'(max-width: 1151px)'}
              srcSet={`${props.src}.webp?w=374&default=vertical&t=${BUILD_TIME}`}
              type={'image/webp'}
            />
            <source
              media={'(min-width: 1152px)'}
              srcSet={`${props.src}.webp?w=287&default=vertical&t=${BUILD_TIME}`}
              type={'image/webp'}
            />
            <source
              media={'(max-width: 767px)'}
              srcSet={`${props.src}.png?w=498&default=vertical&t=${BUILD_TIME}`}
              type={'image/png'}
            />
            <source
              media={'(max-width: 1151px)'}
              srcSet={`${props.src}.png?w=374&default=vertical&t=${BUILD_TIME}`}
              type={'image/png'}
            />
            <source
              media={'(min-width: 1152px)'}
              srcSet={`${props.src}.png?w=287&default=vertical&t=${BUILD_TIME}`}
              type={'image/png'}
            />
          </>
        )}
        <img
          alt={'image'}
          sizes={sizes}
          src={src}
          srcSet={srcSet}
        />
      </picture>
    );
  }, [isPng, src]);

  return (
    <div className={'picture'}>
      <div className={'backdrop'}>
        {image}
      </div>
      {image}
    </div>
  );
};

export default CompletedProjectPicture;